export default __webpack_public_path__ + "static/media/pre-schools-banner-new.a5341539.jpg";